import initCarousel from '../helpers/carousel';
import { unitlessBreakpoints } from '../helpers/breakpoints';

export default class DynamicJobPostings {
  constructor(section) {
    this.el = section.el;
    this.section = section;

    initCarousel(
      this.el,
      {
        perPage: 1,
        perMove: 1,
        type: 'slide',
        autoplay: false,
        pagination: false,
        gap: '24px',
        mediaQuery: 'min',
        breakpoints: {
          [unitlessBreakpoints.lg]: {
            perPage: 2,
          },
        },
      },
      true,
    );
  }
}
